class KeyType {
    static NK = 0; // not a key
    static PK = 1;
    static FK = 2;
}

export default KeyType;